import InterviewDetail from './InterviewDetail'
export default InterviewDetail